// extracted by mini-css-extract-plugin
export default {"tag-list":"index-module__tag-list___kzBMC","tagList":"index-module__tag-list___kzBMC"};